import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoaderService, MobileSSOService } from '~services';

@Component({
  selector: 'app-mobilesso-start-view',
  template: ``,
  standalone: false,
})
export class MobileSSOStartViewComponent implements OnInit, OnDestroy {
  constructor(private mobileSSOService: MobileSSOService, private loaderService: LoaderService) {}

  async ngOnDestroy(): Promise<void> {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
  }
}
